import React from "react"
import { Input } from "reactstrap"

export default function FormItem({ id = "", label = "", ...inputProps }) {
  return (
    <>
      <label className="form-control-label" htmlFor={id}>
        {label}
      </label>
      <Input id={id} {...inputProps} />
    </>
  )
}
